/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Modal/GeneralSettings
 * @desc EntityStateWorkflow Modal GeneralSettings
 */

import { EntityFormShowEditName } from 'labstep-web/components/Entity/Form/ShowEdit/Name';
import { EntityStateActionUpdateColor } from 'labstep-web/components/EntityState/Action/UpdateColor';
import { EntityStateFormShowEditDescription } from 'labstep-web/components/EntityState/Form/ShowEdit/Description';
import { EntityStateFormShowEditTargetAllowedActionsLock } from 'labstep-web/components/EntityState/Form/ShowEdit/TargetAllowedActionsLock';
import { HorizontalTable } from 'labstep-web/core/Table/Horizontal';
import type { EntityState } from 'labstep-web/models/entity-state.model';
import type React from 'react';
import type { EntityStateWorkflowModalGeneralSettingsProps } from './types';

export const EntityStateWorkflowModalGeneralSettings: React.FC<
  EntityStateWorkflowModalGeneralSettingsProps
> = ({ entityState }) => (
  <div data-testid="entity-state-workflow-modal-general">
    <h3>General Settings</h3>
    <HorizontalTable
      headerProps={{ width: 6 }}
      columns={[entityState]}
      rows={[
        {
          header: 'Name',
          content: (state: EntityState) => (
            <EntityFormShowEditName entity={state} />
          ),
        },
        {
          header: 'Color',
          content: (state: EntityState) => (
            <EntityStateActionUpdateColor entityState={state} />
          ),
        },
        {
          header: 'Description',
          content: (state: EntityState) => (
            <EntityStateFormShowEditDescription entityState={state} />
          ),
        },
        {
          header: 'Lock Mode',
          content: (state: EntityState) => (
            <EntityStateFormShowEditTargetAllowedActionsLock
              entityState={state}
            />
          ),
        },
      ]}
    />
  </div>
);
